// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__18-CO","rightAdornment":"Header_rightAdornment__Nx6Hv"};